import React from "react";
import "./portfolio.scss";

const Portfolio = ({ link, src, figcaption, alt }) => {
    return (
        <a href={link} target="_blank" rel="noopener noreferrer">
            <figure>
                <img className="img-fluid" src={src} alt={alt} />
                <figcaption>{figcaption}</figcaption>
            </figure>
        </a>
    );
};

export default Portfolio;